











































































































































































import { TreatmentMonitoringApi } from "../../../apis";
import { ApexOptions } from "apexcharts";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { DataOptions, DataTableHeader } from "vuetify";
import { VueExcelEco2 } from "../common/VueExcelEco2";
import { DataLogModelWrapper, IDataLog } from ".";
import moment from "moment";
import MyDateTimePickerMobile from "../mobile/common/MyDateTimePickerMobile.vue";
@Component({
  components: {MyDateTimePickerMobile},
})
export default class DataLog extends Vue {
  @Prop({ default: false }) value: Boolean;
  @Prop({ default: () => {} }) unit: any;
  @Prop({ default: () => {} }) variables: { text: string; value: string }[];
  @Prop({ default: () => {} }) treatments: any[];

  headers: DataTableHeader[] = [];
  headersVariable: DataTableHeader[] = [];
  dataLogs: IDataLog[] = [];
  dataExport: IDataLog[] = [];
  columnsExport= [];
  searchForm = {
    variables: [],
    from: "",
    to: "",
    treatmentId: "",
  };
  page = 1;
  pageCount = 0;
  itemsPerPage = 10;

  get show() {
    this.searchForm.variables = this.variables.map((val) => val.value);
    this.searchForm.treatmentId = "";
    const today = new Date();
    this.searchForm.to = moment(today)
      .startOf("days")
      .format("YYYY-MM-DD HH:mm");
    this.searchForm.from = moment(today)
      .startOf("days")
      .add(-7, "days")
      .format("YYYY-MM-DD HH:mm");
    this.dataLogs = [];
    this.pageCount = 0;
    this.page = 1;

    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }

  /**
   * Collect all unique variables from all treatment data log models
   * Optimized for large datasets using Map for O(1) lookups
   * Maintains same format as original code: header-variable-${variableId} or header-variable-${index}
   * @param treatmentDataLogModels Array of treatment data log models
   * @returns Array of unique variable headers sorted by first appearance
   */
  private collectAllVariables(treatmentDataLogModels: any[]): DataTableHeader[] {
    if (this.lodash.isEmpty(treatmentDataLogModels)) {
      return [];
    }

    // Use Map to store unique variables by key (variableId or index-based) for O(1) lookup
    // Map preserves insertion order
    // Key format matches original: variableId if exists, otherwise index-based
    const variableMap = new Map<string, { variable: string; key: string; index: number }>();
    let globalIndex = 0;

    // Iterate through all records once to collect all variables
    treatmentDataLogModels.forEach((model) => {
      if (model.dataLogs && Array.isArray(model.dataLogs)) {
        model.dataLogs.forEach((dataLog: any, localIndex: number) => {
          // Match original format: use variableId if exists, otherwise use index
          // This ensures compatibility with existing data mapping logic
          const key = dataLog.variableId ? dataLog.variableId : localIndex.toString();
          // Only add if not already present (first occurrence wins)
          if (!variableMap.has(key)) {
            variableMap.set(key, {
              variable: dataLog.variable || '',
              key: key,
              index: globalIndex++
            });
          }
        });
      }
    });

    // Convert Map to array and sort by first appearance index
    // Format matches original: header-variable-${variableId} or header-variable-${index}
    const headersVariable_: DataTableHeader[] = Array.from(variableMap.values())
      .sort((a, b) => a.index - b.index)
      .map((item) => ({
        text: item.variable,
        value: `header-variable-${item.key}`,
        class: ["tw-whitespace-no-wrap"],
      }));

    return headersVariable_;
  }

  /**
   * Collect all unique variables for export (without class property)
   * Optimized for large datasets using Map for O(1) lookups
   * Maintains same format as original code: variable_${variableId}
   * @param treatmentDataLogModels Array of treatment data log models
   * @returns Array of unique variable headers for export
   */
  private collectAllVariablesForExport(treatmentDataLogModels: any[]): DataTableHeader[] {
    if (this.lodash.isEmpty(treatmentDataLogModels)) {
      return [];
    }

    // Use Map to store unique variables by variableId for O(1) lookup
    // Match original format: variable_${variableId} (original code always uses variableId)
    const variableMap = new Map<string, { variable: string; variableId: string; index: number }>();
    let globalIndex = 0;

    // Iterate through all records once to collect all variables
    treatmentDataLogModels.forEach((model) => {
      if (model.dataLogs && Array.isArray(model.dataLogs)) {
        model.dataLogs.forEach((dataLog: any) => {
          // Original code uses element.variableId directly, so we only collect if variableId exists
          // This matches the original export logic: val['variable_'+element.variableId]
          if (dataLog.variableId) {
            // Only add if not already present (first occurrence wins)
            if (!variableMap.has(dataLog.variableId)) {
              variableMap.set(dataLog.variableId, {
                variable: dataLog.variable || '',
                variableId: dataLog.variableId,
                index: globalIndex++
              });
            }
          }
        });
      }
    });

    // Convert Map to array and sort by first appearance index
    // Format matches original: variable_${variableId}
    const headersVariable_: DataTableHeader[] = Array.from(variableMap.values())
      .sort((a, b) => a.index - b.index)
      .map((item) => ({
        text: item.variable,
        value: `variable_${item.variableId}`,
      }));

    return headersVariable_;
  }

  async doSearch() {
    this.$util.showLoading();
    try {
      const rs = await new TreatmentMonitoringApi().getTreatmentDataLog({
        variableIds: this.lodash.join(this.searchForm.variables, ","),
        orderBy: "logTime",
        orderDesc: "true",
        treatmentId: this.searchForm.treatmentId || '',
        startDate: !this.searchForm.from
          ? ""
          : moment(this.searchForm.from, "YYYY-MM-DD HH:mm")
              .utc()
              .format("YYYY-MM-DD HH:mm"),
        endDate: !this.searchForm.to
          ? ""
          : moment(this.searchForm.to, "YYYY-MM-DD HH:mm")
              .utc()
              .format("YYYY-MM-DD HH:mm"),
        page: this.page,
        limit: this.itemsPerPage,
      });
      const treatmentDataLogModels = rs.data.data;
      this.pageCount = Math.floor(rs.data.count / this.itemsPerPage) + (rs.data.count % this.itemsPerPage > 0 ? 1 : 0);

      this.headers = [
        {
          text: this.$t("text.date").toString(),
          value: "date",
          class: ["tw-whitespace-no-wrap"],
        },
        {
          text: this.$t("text.time").toString(),
          value: "time",
          class: ["tw-whitespace-no-wrap"],
        },
        {
          text: this.$t("text.treatmentId").toString(),
          value: "treatmentId",
          class: ["tw-whitespace-no-wrap"],
        },
      ];

      if (this.lodash.isEmpty(treatmentDataLogModels)) {
        this.dataLogs = [];
        return;
      }
      // Collect all unique variables from all records, not just the first one
      const headersVariable_ = this.collectAllVariables(treatmentDataLogModels);
      this.headersVariable = [...headersVariable_];
      this.headers = [...this.headers, ...headersVariable_];

      const dataLogs_: IDataLog[] = [];
      treatmentDataLogModels.forEach((val) => {
        const logDate = moment(val.logTime);
        const dataLogWrapper = val.dataLogs.map((log, index) => ({
          ...log,
          id: `header-variable-${log.variableId? log.variableId : index}`,
        })) as DataLogModelWrapper[];
        dataLogs_.push({
          date: logDate.format("DD/MM/YYYY"),
          time: logDate.format("HH:mm"),
          treatmentId: !val.treatmentNumber ? "" : "" + val.treatmentNumber,
          dataLogs: this.lodash.groupBy(dataLogWrapper, (item) => item.id),
        });
      });
      this.dataLogs = dataLogs_;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }
  async doExport() {
    this.$util.showLoading();
    try {
      this.dataExport  = [];
      this.columnsExport  = [];
      const rs = await new TreatmentMonitoringApi().getTreatmentDataLog({
        variableIds: this.lodash.join(this.searchForm.variables, ","),
        orderBy: "logTime",
        orderDesc: "true",
        treatmentId: this.searchForm.treatmentId || '',
        startDate: !this.searchForm.from
          ? ""
          : moment(this.searchForm.from, "YYYY-MM-DD HH:mm")
              .utc()
              .format("YYYY-MM-DD HH:mm"),
        endDate: !this.searchForm.to
          ? ""
          : moment(this.searchForm.to, "YYYY-MM-DD HH:mm")
              .utc()
              .format("YYYY-MM-DD HH:mm"),
        page:null,
        limit: null,
      });

      const treatmentDataLogModels = rs.data.data;
      this.pageCount = Math.floor(rs.data.count / this.itemsPerPage) + (rs.data.count % this.itemsPerPage > 0 ? 1 : 0);

      const headers = [
        {
          text: this.$t("text.date").toString(),
          value: "date",
          class: ["tw-whitespace-no-wrap"],
        },
        {
          text: this.$t("text.time").toString(),
          value: "time",
          class: ["tw-whitespace-no-wrap"],
        },
        {
          text: this.$t("text.treatmentId").toString(),
          value: "treatmentId",
          class: ["tw-whitespace-no-wrap"],
        },
      ];

      if (this.lodash.isEmpty(treatmentDataLogModels)) {
        this.dataExport = [];
        return;
      }
      // Collect all unique variables from all records, not just the first one
      const exportHeadersVariable = this.collectAllVariablesForExport(treatmentDataLogModels);
      this.columnsExport =  [...headers, ...exportHeadersVariable].map(c=>{return {'label' : c.text, 'field':c.value};});
      const dataLogs_= [];
      treatmentDataLogModels.forEach((val) => {
        const logDate = moment(val.logTime);
        for (let index = 0; index < val.dataLogs.length; index++) {
          const element = val.dataLogs[index];
          val['variable_'+element.variableId]= element.value;
        }
        dataLogs_.push({
          ...val,
          date: logDate.format("DD/MM/YYYY"),
          time: logDate.format("HH:mm"),
          treatmentId: !val.treatmentNumber ? "" : "" + val.treatmentNumber,
        });
      });
      this.dataExport = dataLogs_;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      const unitInfo = this.unit?  " [" + this.unit.location.locationName +'][' + this.unit.name+ "]": "";
      const exportExcel = new VueExcelEco2(
        "ECO2 - Export Data Log" + unitInfo,
        "xlsx",
        "ECO2 Web",
        this.dataExport,
        this.columnsExport
      ).exportExcel();
      this.$util.hideLoading();
    }
  }
}
